import type { ComponentType } from 'react'
import { Navigate, type RouteObject } from 'react-router-dom'
import { AuthGuard } from '@/platform/auth/ui/AuthGuard'
import { RouteErrorBoundary } from './RouteErrorBoundary'
import { FullPageLoader } from '@/shared/ui/FullPageLoader'
import { AppLayout } from '@/platform/shell/AppLayout'

function lazyPage(loader: () => Promise<{ default: ComponentType }>) {
  return async () => ({ Component: (await loader()).default })
}

export const routes: RouteObject[] = [
  {
    path: '/', HydrateFallback: FullPageLoader, errorElement: <RouteErrorBoundary />, element: <AppLayout />, children: [
      { index: true, lazy: lazyPage(() => import('@/platform/workspace-catalog/pages/WorkspaceEntryPage')) },
      { path: 'workspaces', lazy: lazyPage(() => import('@/platform/workspace-catalog/pages/WorkspacePickerPage')) },
    ],
  },
  {
    element: <AuthGuard />, HydrateFallback: FullPageLoader, errorElement: <RouteErrorBoundary />, children: [
      { path: '/english/*', lazy: lazyPage(() => import('@/workspaces/english/app/EnglishWorkspaceEntry')) },
    ],
  },
  { path: '/auth/callback', HydrateFallback: FullPageLoader, errorElement: <RouteErrorBoundary />, lazy: lazyPage(() => import('@/platform/auth/pages/AuthCallbackPage')) },
  { path: '/lexicals/*', element: <Navigate to="/english" replace /> },
  { path: '*', element: <Navigate to="/" replace /> },
]
